import React from 'react';
import _ from 'lodash';
import moment from 'moment';
import { connect } from 'react-redux';
import TranslatedLink from './TranslatedLink.jsx';
import { appContext } from '../util/decorators';
import blogConfig from '../config/blogConfig.json';
import podcastConfig from '../config/podcastConfig.json';
import { getSportUrlParam } from '../util/getArticleLink';

const mapStateToProps = state => ({
  country: state.country,
  language: state.language,
  siteBlogs: blogConfig[state.country],
  sitePodcasts: podcastConfig[state.country],
});

// Might want to move this function to an util file if we find it usuable in more places
const addSeparator = (array, separator) => _.chain(array).flatMap((item, i) => [!!i && separator, item]).compact().value();

@connect(mapStateToProps)
@appContext
export default class ContentMeta extends React.PureComponent {
  getTags() {
    const { data: { tags }, blogs, podcasts, useVideoTypeTags, customTags, country } = this.props;
    if (!tags) {
      return [];
    }
    const result = [];
    const competition = _.head(tags.competitions);
    const videoTypes = (() => {
      switch (typeof tags.videoTypes) {
      case 'object':
        return Array.isArray(tags.videoTypes) ? tags.videoTypes.join(',').split(',') : [];
      case 'string':
        return tags.videoTypes.split(',');
      default:
        return [];
      }
    })();
    const videoType = _.without(videoTypes, 'vce-clip', '48hclip', 'angle')[0];
    const blog = _.find(blogs, { id: _.head(tags.blogs) });
    const podcast = _.find(podcasts, { id: _.head(tags.podcasts) });

    if (customTags) {
      _.each(customTags, tag => result.push({name: tag}));
    } else if (useVideoTypeTags) {
      if (videoType) {
      //console.log(`competition videoType: ` + videoType);
        result.push({
          slug: videoType,
          name: this.context.app.t('ContentMeta.' + videoType.toLowerCase()),
          linkTemplate: 'VideoType',
        });
      }
    } else if (competition) {
     //console.log(`competition: ` +JSON.stringify(competition));
      result.push({
        slug: competition.en.slug,
        name: _.get(competition, `${country}.name`, _.get(competition, `en.name`)),
        linkTemplate: 'LeaguePage',
      });
      
      if (videoType) {
      //console.log(`competition videoType: ` +JSON.stringify(videoType));
        result.push({
          slug: videoType,
          name: this.context.app.t('ContentMeta.' + videoType.toLowerCase()),
          linkTemplate: 'VideoType',
        });
      }
    }

    if (blog) {
      result.push({
        slug: blog.id,
        name: blog.name,
        linkTemplate: 'BlogPage',
      });
    }

    if (podcast) {
      result.push({
        slug: podcast.id,
        name: podcast.name,
        linkTemplate: 'PodcastPage',
      });
    }

    return result;
  }

  getSport() {
    const sport = _.get(this.props.data, 'tags.sports[0].en.slug');
    return getSportUrlParam(this.props.country, sport);
  }

  getTimeLabel() {
    const { language, noTimestamp, data: { settings } } = this.props;
    if (noTimestamp || !settings.publishTimestamp) return;

    const momentedTime = moment(settings.publishTimestamp).locale(language);
    const showRelativeTime = this.context.app.serverTime().diff(momentedTime, 'hours') < 12;
    const date = showRelativeTime ? momentedTime.fromNow() : momentedTime.format('YYYY-MM-DD');

    return <span className="date"><i className="icon-time"></i>{date}</span>;
  }

  render() {
    const tags = this.getTags();
    const sport = this.getSport();
    const time = this.getTimeLabel();
//console.log(`competition tags: ` +JSON.stringify(tags));
    const tagViews = addSeparator(
      _.chain(tags)
        // Remove tags with empty name
        .filter(tag => Boolean(tag.name))
        .map(tag =>
        tag.linkTemplate ?
          <TranslatedLink key={tag.name.replace('Superligaen', '3F Superliga').replace('Danmark DBU Pokalen', 'Oddset Pokalen').replace('Danmark 1. Division', 'NordicBet Liga').replace('Dakar Rally', 'Formel 2').replace('Moto3', 'Formel 3').replace('British Superbike', 'IMSA')} className="tag-text" routeParams={[sport, tag.slug.replace('dakar-rally', 'formula-2').replace('moto-3', 'formula-3').replace('british-superbike', 'imsa').replace('rio-2016', 'tokyo-2021')]} name={tag.linkTemplate.replace('Superligaen', '3F Superliga').replace('Danmark DBU Pokalen', 'Oddset Pokalen').replace('Danmark 1. Division', 'NordicBet Liga').replace('Dakar Rally', 'Formel 2').replace('Moto3', 'Formel 3').replace('British Superbike', 'IMSA').replace('Rio 2016', 'Tokyo 2021')}>{tag.name.replace('Superligaen', '3F Superliga').replace('Danmark DBU Pokalen', 'Oddset Pokalen').replace('Danmark 1. Division', 'NordicBet Liga').replace('Dakar Rally', 'Formel 2').replace('Moto3', 'Formel 3').replace('British Superbike', 'IMSA').replace('E-sport', 'eSuperliga').replace('Rio 2016', 'Tokyo 2021')}</TranslatedLink> :
          <span key={tag.name} className="tag-text">{tag.name}</span>
      )
    , ', ');

    return (
      <div className="meta">
        { time }
        {
          !_.isEmpty(tagViews) && !this.props.hideTags &&
            <div className="tags">
              { tagViews }
            </div>
        }
      </div>
    );
  }
}

ContentMeta.propTypes = {
  data: React.PropTypes.object.isRequired,
  hideTags: React.PropTypes.bool,
  noTimestamp: React.PropTypes.bool,
  country: React.PropTypes.string,
  language: React.PropTypes.string,
  blogs: React.PropTypes.array,
  podcasts: React.PropTypes.array,
};



// WEBPACK FOOTER //
// ./src/component/ContentMeta.jsx